export const routePath = (list, name) => {
  return list[name]
}

export const routeTo = (list, name, params) => {
  let url = routePath(list, name)
  if(params) Object.entries(params).map(prop => url = url.replace(`:${prop[0]}`, prop[1]))

  return url
}
